// 半角英数字のみ入力可能にする関数
function restrictToAlphaNumeric(inputElement) {
  inputElement.addEventListener('input', function(e) {
    // 全角文字を削除し、半角英数字のみ残す
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z0-9]/g, '');
    e.target.value = value;
  });
  
  // ペースト時の処理
  inputElement.addEventListener('paste', function(e) {
    setTimeout(() => {
      let value = e.target.value;
      value = value.replace(/[^a-zA-Z0-9]/g, '');
      e.target.value = value;
    }, 0);
  });
}

// 半角数字のみ入力可能にする関数
function restrictToNumeric(inputElement) {
  inputElement.addEventListener('input', function(e) {
    // 全角文字を削除し、半角数字とハイフンのみ残す
    let value = e.target.value;
    value = value.replace(/[^0-9\-]/g, '');
    e.target.value = value;
  });
  
  // ペースト時の処理
  inputElement.addEventListener('paste', function(e) {
    setTimeout(() => {
      let value = e.target.value;
      value = value.replace(/[^0-9\-]/g, '');
      e.target.value = value;
    }, 0);
  });
}

// メールアドレス用：半角英数字と半角記号のみ入力可能にする関数
function restrictToEmailFormat(inputElement) {
  inputElement.addEventListener('input', function(e) {
    // 全角文字を削除し、メールアドレス用文字のみ残す
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z0-9._%+\-@]/g, '');
    e.target.value = value;
  });
  
  // ペースト時の処理
  inputElement.addEventListener('paste', function(e) {
    setTimeout(() => {
      let value = e.target.value;
      value = value.replace(/[^a-zA-Z0-9._%+\-@]/g, '');
      e.target.value = value;
    }, 0);
  });
}

// DOMContentLoaded時に初期化
document.addEventListener('DOMContentLoaded', function() {
  console.log('Input control script loaded');
  
  // すべてのメールアドレス入力フィールドに制御を適用
  const allEmailInputs = document.querySelectorAll('input[type="email"], input[name*="email"]');
  console.log('Found email inputs:', allEmailInputs.length);
  allEmailInputs.forEach(function(input, index) {
    console.log('Applying email restriction to input', index + 1);
    restrictToEmailFormat(input);
  });
  
  // すべてのパスワード入力フィールドに制御を適用（ニックネーム以外）
  const allPasswordInputs = document.querySelectorAll('input[type="password"]');
  console.log('Found password inputs:', allPasswordInputs.length);
  allPasswordInputs.forEach(function(input, index) {
    console.log('Applying password restriction to input', index + 1);
    restrictToAlphaNumeric(input);
  });
  
  // お客様番号（数字のみ）
  const customerCodeInputs = document.querySelectorAll('#customer_code, input[name*="customer_code"], input[name="customer_id"]');
  customerCodeInputs.forEach(function(input) {
    console.log('Applying numeric restriction to customer code');
    restrictToNumeric(input);
  });
  
  // 電話番号（数字とハイフンのみ）
  const phoneInputs = document.querySelectorAll('#phone_number, #phone1, input[name*="phone"]');
  phoneInputs.forEach(function(input) {
    console.log('Applying numeric restriction to phone');
    restrictToNumeric(input);
  });
  
  // admin側の検索フォームなど（customer_code, email など）
  const adminCustomerCodeInputs = document.querySelectorAll('input[name="customer_code"]');
  adminCustomerCodeInputs.forEach(function(input) {
    console.log('Applying numeric restriction to admin customer code');
    restrictToNumeric(input);
  });
  
  // admin側のテキストフィールドでメールアドレス用途のもの
  const adminEmailSearchInputs = document.querySelectorAll('input[name="email"]:not([type="email"])');
  adminEmailSearchInputs.forEach(function(input) {
    console.log('Applying email restriction to admin email search');
    restrictToEmailFormat(input);
  });
});